import { TitleResponseItem, TitleResponseList } from '@/types/service-response'

export class Title {
  public constructor (
    readonly id: number,
    readonly name: string
  ) {}

  static createFromResponse (responseData: TitleResponseList): Array<Title> {
    let result: Array<Title> = []
    if (responseData) {
      result = responseData.map((title: TitleResponseItem ) => {
        return new Title(
          title.ID,
          title.Bezeichnung,
        )
      })
    }
    return result
  }
}
